import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListVariables = () => {
    return axios.get(`/api/SkVariable/variable/list`, { headers: authHeaderJson() } )
};

const getVariableById = (variableId) => {
        return axios.get(`/api/SkVariable/variable/${variableId}`, { headers: authHeaderJson() } );
};

const addVariable = (variable) => {
    return axios.post(`/api/SkVariable/variable/add`, variable, { headers: authHeaderJson() } );
}

const addVariableList = (variables) => {
    return axios.post(`/api/SkVariable/variable/add/list`, variables, { headers: authHeaderJson() } );
}

const saveVariableById = (variableId, objContract) => {
    return axios.put(`/api/SkVariable/variable/${variableId}`, objContract, { headers: authHeaderJson() });
};

const deleteVariable = (variableId) => {
    return axios.delete(`/api/SkVariable/variable/${variableId}`, { headers: authHeaderJson() });
}

export {
    getListVariables,
    getVariableById,
    addVariable,
    addVariableList,
    saveVariableById,
    deleteVariable
}